import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { KeyingAuthService } from '../services/keying.auth.service';

@Injectable({
  providedIn: 'root',
})
export class SuperUserGuard {
  constructor(
    private keyingAuthService: KeyingAuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.keyingAuthService.keyingUser$.pipe(
      take(1),
      map((user) => {
        if (user && user.isSuperUser === true) {
          return true;
        }
        // Redirect to main page if not a SuperUser
        return this.router.createUrlTree(['/']);
      })
    );
  }
}
